import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {filter, switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UnverifiedGuard  {

  constructor(private afAuth: AngularFireAuth, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.afAuth.user
      .pipe(
        filter(u => u != null),
        switchMap(u => u.getIdTokenResult().then((res) => {
          if (res.claims.verified) {
            this.router.navigate(['/']);
          } else if (res.claims.blocked) {
            this.router.navigate(['/blocked']);
          }
          return !(res.claims.verified || res.claims.blocked);
        }))
      );
  }


}
